import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TCreateEarmarkConversionAPIParams } from '~types/feat/gold';
import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { ErrorMessages } from '~utils/constants';

export default function* watchCreateEarmarkConversion(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldCreateEarmarkConversionAttempt', handleCreateEarmarkConversion, api);
}

function* handleCreateEarmarkConversion(api: GoldGateway, data: PayloadAction<TCreateEarmarkConversionAPIParams>) {
    const authToken = store.getState().auth.userDetails.authToken;
    const { transactionId, earmarkEndDate, projectId } = data.payload;

    if (!transactionId || !earmarkEndDate || !projectId) {
        yield put(combinedActions.goldCreateEarmarkConversionFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.createEarmarkConversion], {
        authToken,
        transactionId,
        earmarkEndDate,
        projectId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldCreateEarmarkConversionFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldCreateEarmarkConversionSuccess());
    }
}
